export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_SIDEBAR_LOCKED = 'TOGGLE_SIDEBAR_LOCKED'
export const RESET_SIDEBAR = 'RESET_SIDEBAR'
export const EXPAND_SIDEBAR_OPTION = 'EXPAND_SIDEBAR_OPTION'
